import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Button, Card, Col, Icon, Input, Radio, Row, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {Link, RouteComponentProps, withRouter} from 'react-router-dom';
import {CompaniesStore, CompanySummary} from 'src/stores/companies-store';
import {DataStore, ItemState, Query} from 'src/core/stores/dataStore';
import {TableModel, TableView} from 'src/core/ui/collections/table';
import HttpService, {formatMessage} from 'src/core/services/http.service';
import {CommandResult} from '../../../core/stores/types';
import NewCompanyView from './company-new';
import ContentTitle from 'src/core/ui/content-header';
import {withIdentity} from 'src/core/services/authentication';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import {navigate} from '../../../core/ui/link';
import {CacheProps, withCache} from '../../../core/services/cache.service';
import {resolve} from 'src/inversify.config'
import FileSaver from 'file-saver';
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";
import {isReadOnly} from "../../../utils/CheckValidationbyUsers";
import { successNotification } from 'src/components/systemNotifications/notificationService';

// tslint:disable-next-line:no-empty-interface
interface CompaniesViewProps extends RouteComponentProps<{ companyId: string }>, WithTranslation, UserProfileProps , CacheProps {

}

interface CompaniesViewState {
    query: Query;
    newCompanyShown: boolean;
}

@connect(['companies', CompaniesStore])
class CompaniesDashboard extends React.Component<CompaniesViewProps, CompaniesViewState> {
    private get companiesStore() {
        return (this.props as any).companies as CompaniesStore;
    }
    @resolve(HttpService)
    private httpService!: HttpService
    constructor(props: CompaniesViewProps) {


        //Clear all cache
        props.cache.clearCacheByPath()
        var queryStored = props.cache.get()
        var query = { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }], skip: 0, take: 10, parameters: { justAllowedRoles: true}};
        super(props);
      
        if (queryStored)
            query = queryStored

        this.state = {
            query: query as any,
            newCompanyShown: false,
        };
    }

    componentWillMount() {
        if (!this.checkAuth())
            this.props.history.push('/');
        if (!this.props.cache.isInCache()) {
            this.load(this.state.query)
        }
    }

    componentWillUpdate() {
        if (!this.checkAuth())
            this.props.history.push('/');
    }

    componentDidMount() {
        this.load(this.state.query)
    }

    @autobind
    private checkAuth() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Manager")
                || this.props.userProfile.roles.includes("Pmo Manager")
                || this.props.userProfile.roles.includes("Pmo Administrator")
                || this.props.userProfile.roles.includes("Administrator")
                || this.props.userProfile.roles.includes("Pmo ClientAdmin")
                || this.props.userProfile.roles.includes("ClientAdmin")
                || this.props.userProfile.roles.includes("Pmo FIConsultant")
                || this.props.userProfile.roles.includes("FIConsultant")
                || this.props.userProfile.roles.includes("CompanyDataViewer")
            );
    }

    @autobind
    private canNotDeleteCompanies() {
      return (this.props.userProfile && this.props.userProfile.roles &&
            !(this.props.userProfile.roles.includes("Administrator") || this.props.userProfile.roles.includes("FIConsultant")) && (this.props.userProfile.roles.includes("CompanyDataViewer") || this.props.userProfile.roles.includes("Manager")));
    }

    @autobind
    private checkAuthAdmin() {
        return this.props.userProfile && this.props.userProfile.roles && (this.props.userProfile.roles.includes("Administrator"))
    }

    @autobind
    private checkAuthAdminFi() {
        return this.props.userProfile && this.props.userProfile.roles && (this.props.userProfile.roles.includes("FIConsultant"))
    }

    @autobind
    private canNotCreateCompanies() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            !(this.props.userProfile.roles.includes("Administrator") || this.props.userProfile.roles.includes("FIConsultant")) && (this.props.userProfile.roles.includes("CompanyDataViewer") || this.props.userProfile.roles.includes("Manager") || this.props.userProfile.roles.includes("ClientAdmin") ))
    }

    @autobind
    private load(query: Query) {
        this.props.cache.save(query,true,true);
        this.companiesStore.getAllAsync(query);
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    @autobind
    private async onDeleteRow(item: CompanySummary, state: ItemState): Promise<CommandResult<any>> {
        return await this.companiesStore.deleteAsync(`${item.id}`);
    }

    @autobind
    private onNewItem() {
        this.setState({ newCompanyShown: true });
    }

    @autobind
    private onNewItemClosed(id: string | undefined) {
        this.setState({ newCompanyShown: false });
        this.load(this.state.query);
    }

    @autobind
    private async downloadExcel() {
        const { query } = this.state;   
        await this.httpService.get(`api/v1/companies/list?${DataStore.buildUrl(query)}`, {
            responseType: 'arraybuffer'
        });

        successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));
    }

    public render() {
        const { t } = this.props as any;
        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'title',
                    title: t('Company Name'),
                    renderer: (data) => <span>

                        <Link to={{
                            pathname: `/time-tracking/admin/companies/${data.id}`,
                            state: {
                                titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : []),
                                    { url: `/time-tracking/admin/companies/${data.id}`, title: data.title }]
                            }
                        }}>
                       <Icon type="cluster" />&nbsp;<span>{data.title}</span></Link>
                    </span>,
                    editor: (data) => <Input />
                },
                {
                    field: 'reference',
                    title: <EditableTooltip name='company-reference'> {t('Reference')} </EditableTooltip>,
                    renderer: (data) => <span>{data.reference}</span>,
                    editor: (data) => <Input />
                },
                {
                    field: 'tenantName',
                    title: <EditableTooltip name='tenantName'> {t('Tenant')} </EditableTooltip>,
                    renderer: (data) => <span>{data.tenantName}</span>,
                    editor: (data) => <Input />
                },
            ],
            data: this.companiesStore.state,
            sortFields: [{
                field: 'title',
                text: t('Name'),
                useProfile: false
            }],
        } as TableModel<CompanySummary>;

        return <div>
            <Row gutter={0}>
                <Col span={10}> 
                    <ContentTitle title={t("Companies")} />
                </Col>
                <Col span={14} style={{ marginTop: 40 }}>
                    <Radio.Group style={{ float: 'right' }} value="companies-settings">
                        <Radio.Button value="companies-settings">{t('Companies Settings')}</Radio.Button>
                        {this.checkAuthAdminFi() && <Radio.Button value="app-settings" onClick={() => navigate(this.props.history, `/time-tracking/admin/appsettings/`)}>{t('Application Settings')}</Radio.Button>}
                      
                    </Radio.Group>
                </Col>
            </Row>
            <Row type={'flex'} align='top' justify='space-between'>
                <Card style={{ width: '100%', marginTop:8 }}>
                    <Spin size='large' spinning={this.companiesStore.state.isBusy}>
                        <TableView
                            showDeleteStatusWindow
                            rowKey='id'
                            model={tableModel}
                            error={this.companiesStore.state.result && !this.companiesStore.state.result.isSuccess && formatMessage(this.companiesStore.state.result)}
                            embedded={false}
                            onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                            onRefresh={() => this.load(this.state.query)}
                            canEdit={false}
                            canDelete={!this.canNotDeleteCompanies()}
                            onDeleteRow={this.onDeleteRow}
                            canCreateNew={!isReadOnly(this.props.userProfile)}
                            onNewItem={this.onNewItem}
                            rightToolbar={
                                <ul>
                                    <li >
                                        <Button icon="download" onClick={this.downloadExcel} />
                                    </li>
                                    
                                </ul>}
                        >
                        </TableView>
                        {this.state.newCompanyShown &&
                            <NewCompanyView
                                userProfile={this.props.userProfile}
                                onClose={this.onNewItemClosed}
                            />}
                    </Spin>
                </Card>
            </Row>
        </div>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withCache(withTranslation()(withIdentity(withRouter(CompaniesDashboard)))));
